import { useEffect, useState } from "react";
import client from "@/lib/api";

// The role -> permissions catalogue, fetched from GET /api/roles rather than
// duplicated in the frontend (see lib/permissions.js for why). Used by the
// Users page to render the role assignment grid and to show what each role
// actually grants.
//
// Module-level cache: the catalogue is a static vocabulary that only changes
// on deploy, so every mounting component shares a single request.
let cache = null;
let inFlight = null;

export function useRoleCatalogue() {
  const [catalogue, setCatalogue] = useState(cache);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cache) return undefined;
    let cancelled = false;
    if (!inFlight) inFlight = client.get("/roles").then((r) => r.data);
    inFlight
      .then((data) => {
        cache = data;
        if (!cancelled) setCatalogue(data);
      })
      .catch((e) => {
        inFlight = null; // let a remount retry rather than caching the failure
        if (!cancelled) setError(e);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    catalogue,
    error,
    loading: !catalogue && !error,
    mhqRoles: catalogue?.mhq_roles || [],
    dealerRoles: catalogue?.dealer_roles || [],
    permissionsOf: (role) => catalogue?.role_permissions?.[role] || [],
  };
}
